module.exports = __webpack_public_path__ + "static/media/icon-home-tag6.1c806574.png";